import { tasksConstants } from './constants';

export const initialState = {
  data: [],
  meta: null,
  pending: false,
  requestId: null,
};

export function tasks(state = initialState, action) {
  switch (action.type) {
    case tasksConstants.GET_TASKS_REQUEST:
      // Preserve meta across requests so filter dropdowns don't blank out between pagination
      // fetches that intentionally omit filter_options.
      return {
        ...initialState,
        meta: state.meta,
        pending: true,
        requestId: action.requestId,
      };
    case tasksConstants.GET_TASKS_SUCCESS:
      if (action.requestId !== state.requestId) return state;

      return {
        ...state,
        data: action.tasks,
        meta:
          action.meta && !action.meta.filterOptions && state.meta?.filterOptions
            ? { ...action.meta, filterOptions: state.meta.filterOptions }
            : action.meta,
        pending: false,
      };
    case tasksConstants.GET_TASKS_FAILURE:
    default:
      return state;
  }
}
